import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { FeatureFlagApi } from '../../api/FeatureFlagApi';
import { updateTableData } from '../../store/utilities/SliceDataHelper';
import { EDataTableType } from '../../data/Constants';

const initialState = {
  featureFlags: {
    data: {},
    totalCount: 0,
    currentPage: 1,
    searchKey: '',
    searchData: {},
    recordsPerPage: 0,
  },
};

//Feature flag thunks
//Gets the paginated feature flags
export const getFeatureFlags = createAsyncThunk(
  'featureFlags/getFeatureFlags',
  async (
    action: { page: number; limit: number; searchCode?: string; activeOnly?: boolean },
    thunkAPI
  ) => {
    return FeatureFlagApi.getFeatureFlags(action, thunkAPI.dispatch);
  }
);

//To create a feature flag
export const createFeatureFlag = createAsyncThunk(
  'featureFlags/createFeatureFlag',
  async (action: { request }, thunkAPI) => {
    return FeatureFlagApi.createFeatureFlag(action, thunkAPI.dispatch);
  }
);

//To update a feature flag
export const updateFeatureFlag = createAsyncThunk(
  'featureFlags/updateFeatureFlag',
  async (action: { request }, thunkAPI) => {
    return FeatureFlagApi.updateFeatureFlag(action, thunkAPI.dispatch);
  }
);

//To get feature flag details
export const getFeatureFlagDetails = createAsyncThunk(
  'featureFlags/getFeatureFlagDetails',
  async (action: { request }, thunkAPI) => {
    return FeatureFlagApi.getFeatureFlagDetails(action, thunkAPI.dispatch);
  }
);

//To delete feature flag(s)
export const deleteFeatureFlags = createAsyncThunk(
  'featureFlags/deleteFeatureFlags',
  async (action: { request }, thunkAPI) => {
    return FeatureFlagApi.deleteFeatureFlags(action, thunkAPI.dispatch);
  }
);

const featureFlagsSlice = createSlice({
  name: 'featureFlags',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getFeatureFlags.fulfilled, (state, action) => {
      if (!action.payload.error) {
        return updateTableData(
          state.featureFlags,
          action.payload,
          !!action.payload.searchKey,
          EDataTableType.FeatureFlags
        );
      }
      return state;
    });
  },
});

export default featureFlagsSlice.reducer;
